<div class="form__group">
  <input
    #inputFile
    accept=".pdf, .png, .jpg, .webp, .jpeg, .svg, .apng, .doc, .docx, .docs, .txt, .xls, .xlsx, .ods, .ppt, .pptx, .tiff, .kmz, .kml, .heic, .heif"
    (change)="upload($event, inputFile)"
    [attr.id]="randomId"
    class="file-upload d-none"
    type="file"
    [multiple]="multipleFile"
  />
  <div
    class="upload-container"
    appDnd
    (fileDropped)="upload($event, inputFile)"
    [ngClass]="{ changePadding: changePadding }"
    (click)="inputFile.click()"
  >
    <button type="button" class="upload-btn">
      <i class="fa fa-upload" aria-hidden="true"></i> Upload
    </button>
  </div>

  <table class="table mt-4" *ngIf="uploadedImages.length > 0 && addDoc">
    <thead>
      <tr>
        <th>File Name</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of uploadedImages; let i = index">
        <td>
          <input
            placeholder="{{ item.name ?? item.fileName | slice: 0:30 }}"
            type="text"
            [(ngModel)]="item.name"
            class="form-control"
            (ngModelChange)="onFileNameChangeHandler(item.name, i)"
            />
        </td>
        <td>
          <i
            class="fa fa-trash theme-text-color mt-2 pt-1"
            aria-hidden="true"
            (click)="remove(item, inputFile)"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>
